"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BooleanMarshaller = exports.DEFAULT_BOOLEAN_FALSE_TOKENS = exports.DEFAULT_BOOLEAN_TRUE_TOKENS = void 0;
const zod_1 = require("zod");
exports.DEFAULT_BOOLEAN_TRUE_TOKENS = ['true', 't', 'yes', 'on', '1'];
exports.DEFAULT_BOOLEAN_FALSE_TOKENS = ['false', 'f', 'no', 'off', '0'];
//don't mess with my consts
Object.freeze(exports.DEFAULT_BOOLEAN_TRUE_TOKENS);
Object.freeze(exports.DEFAULT_BOOLEAN_FALSE_TOKENS);
/* eslint-disable @typescript-eslint/no-explicit-any */
const BooleanMarshaller = (v, options) => {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    let resolved;
    return v.superRefine((val, ctx) => {
        const valueType = typeof val;
        const isNulled = valueType === 'undefined' || val === null;
        const trueTokens = options?.trueTokens || exports.DEFAULT_BOOLEAN_TRUE_TOKENS;
        const falseTokens = options?.falseTokens || exports.DEFAULT_BOOLEAN_FALSE_TOKENS;
        if (isNulled) {
            if (options?.nullable === true) {
                resolved = val;
            }
            else {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.invalid_type,
                    message: 'value must not be nullish',
                    expected: 'unknown',
                    received: valueType,
                });
            }
            return;
        }
        switch (valueType) {
            case 'string':
                {
                    if (val === ''
                        && options?.nullable
                        && 'emptyStringAsNull' in options
                        && options?.emptyStringAsNull === true) {
                        resolved = null;
                        return;
                    }
                    const valAsLower = val.toLowerCase();
                    if (trueTokens.some(token => token.toLowerCase() === valAsLower)) {
                        resolved = true;
                    }
                    else if (falseTokens.some(token => token.toLowerCase() === valAsLower)) {
                        resolved = false;
                    }
                    else {
                        const allTokens = trueTokens.concat(falseTokens.filter(item => trueTokens.indexOf(item) < 0)).join(', ');
                        ctx.addIssue({
                            code: zod_1.z.ZodIssueCode.invalid_type,
                            message: `value must be one of: ${allTokens}`,
                            expected: 'string',
                            received: valueType,
                        });
                    }
                    break;
                }
            default:
                resolved = Boolean(val);
                break;
        }
    }).transform(() => resolved);
};
exports.BooleanMarshaller = BooleanMarshaller;
//# sourceMappingURL=ZodBooleanMarshaller.js.map